import { DEFAULT_MAX_COUNT } from '../Counter.constants'
import { getCounterValue } from '../Counter.utils'

function CounterValue({
  count,
  fixed,
  maxCount = DEFAULT_MAX_COUNT,
  ...restProps
}) {
  return count > 0 ? (
    <span {...restProps}>{getCounterValue(count, fixed, maxCount)}</span>
  ) : null
}

export default CounterValue
